import React from "react";
import { useTranslation } from "../../i18n/hooks";

const ScoreBreakdownTable = ({
    titleScores,
    descriptionScores,
    tagScores,
    seoScores,
  }: {
    titleScores: Record<string, number>;
    descriptionScores: Record<string, number>;
    tagScores: Record<string, number>;
    seoScores: Record<string, number>;
  }) : React.JSX.Element => {
    const calculateTotal = (scores: Record<string, number>): number =>
      Object.values(scores).reduce((sum, value) => sum + value, 0);
    
    const { t } = useTranslation();
  
    return (
      <div className="mt-4 overflow-x-auto">
        <table className="min-w-full text-xs">
          <thead>
            <tr>
              <th className="text-left px-4 py-2 bg-gray-100">{t('scoreBreakdownTable.component')}</th>
              <th className="text-left px-4 py-2 bg-gray-100">{t('scoreBreakdownTable.metric')}</th>
              <th className="text-right px-4 py-2 bg-gray-100">{t('scoreBreakdownTable.score')}</th>
            </tr>
          </thead>
          <tbody>
            {/* Title Scores */}
            {Object.entries(titleScores).map(([key, value]) => (
              <tr key={`title-${key}`} className="border-b border-gray-100">
                <td className="px-4 py-2 text-gray-600">{t('scoreBreakdownTable.title')}</td>
                <td className="px-4 py-2">{key.split("_").join(" ")}</td>
                <td className="px-4 py-2 text-right">{value}</td>
              </tr>
            ))}
            <tr className="bg-gray-50">
              <td className="px-4 py-2 font-medium">{t('scoreBreakdownTable.title_total')}</td>
              <td></td>
              <td className="px-4 py-2 text-right font-medium">
                {calculateTotal(titleScores)}
              </td>
            </tr>
  
            {/* Description Scores */}
            {Object.entries(descriptionScores).map(([key, value]) => (
              <tr key={`desc-${key}`} className="border-b border-gray-100">
                <td className="px-4 py-2 text-gray-600">{t('scoreBreakdownTable.description')}</td>
                <td className="px-4 py-2">{key.split("_").join(" ")}</td>
                <td className="px-4 py-2 text-right">{value}</td>
              </tr>
            ))}
            <tr className="bg-gray-50">
              <td className="px-4 py-2 font-medium">{t('scoreBreakdownTable.description_total')}</td>
              <td></td>
              <td className="px-4 py-2 text-right font-medium">
                {calculateTotal(descriptionScores)}
              </td>
            </tr>
  
            {/* Tag Scores */}
            {Object.entries(tagScores).map(([key, value]) => (
              <tr key={`tags-${key}`} className="border-b border-gray-100">
                <td className="px-4 py-2 text-gray-600">{t('scoreBreakdownTable.tags')}</td>
                <td className="px-4 py-2">{key.split("_").join(" ")}</td>
                <td className="px-4 py-2 text-right">{value}</td>
              </tr>
            ))}
            <tr className="bg-gray-50">
              <td className="px-4 py-2 font-medium">{t('scoreBreakdownTable.tags_total')}</td>
              <td></td>
              <td className="px-4 py-2 text-right font-medium">
                {calculateTotal(tagScores)}
              </td>
            </tr>
  
            {/* SEO Scores */}
            {Object.entries(seoScores).map(([key, value]) => (
              <tr key={`seo-${key}`} className="border-b border-gray-100">
                <td className="px-4 py-2 text-gray-600">{t('scoreBreakdownTable.seo')}</td>
                <td className="px-4 py-2">{key.split("_").join(" ")}</td>
                <td className="px-4 py-2 text-right">{value}</td>
              </tr>
            ))}
            <tr className="bg-gray-50">
              <td className="px-4 py-2 font-medium">{t('scoreBreakdownTable.seo_total')}</td>
              <td></td>
              <td className="px-4 py-2 text-right font-medium">
                {calculateTotal(seoScores)}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  };
  

  export default ScoreBreakdownTable;